import classnames from 'classnames'

export default function ErrDisplay (props: any) {
  const { errors, terminalType } = props;
  return (
    <>
      <div style={{ fontSize: '12px'}}>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80055', '错误提示')}</div>
      <div style={{ fontWeight: 700, fontSize: '14px', marginTop: '2px' }}>{lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80056', '以下字段有误(或存在必填项)')}</div>
      {errors.form &&
        <>
          <p className="err-display-line">
            {Object.values(errors.form.errDetail).map((err: any, index, errs) => {
              const $classnames = classnames(["err-field", terminalType === '3' ? 'mob' : ''])
              return <span className={$classnames}>{err.fieldName + ((index < errs.length - 1) ? '、' : '')}</span>//@notranslate
            })}
          </p>
        </>
      }
      {!!errors.tables?.length && <hr style={{margin: '5px 0px'}}></hr>}
      {
        !!errors.tables?.length &&
        errors.tables.map((table) => {
          const $classnames = classnames(["err-field", terminalType === '3' ? 'mob' : ''])
          return (
            <div className="err-display-block">
              <div style={{ fontWeight: 700, marginBottom: '2px', fontSize: '12px' }}>{table.caption}:</div>
              {table.requiredErr && <p className="err-display-line"><span className={$classnames}>{lang.templateByUuid('UID:P_CORE-YNF-FE_1B1F9A5205F00007', '不能为空')}</span></p>}
              {table.errors.map((err) => {
                return (
                  <p className="err-display-line">
                    {lang.localeUuid('UID:P_CORE-YNF-FE_189530CC05B80003', {num: err.rowIndex + 1}, '【第<%=num%>行】')/*【第<%=num%>行】*/}
                    {Object.values(err.errDetail).map((err: any, index, errs) => {
                      return <span className={$classnames}>{err.fieldName + ((index < errs.length - 1) ? '、' : '')}</span>//@notranslate
                    })}
                  </p>
                )
              })}
            </div>
          )
        })
      }
    </>
  )
}